import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 8px;
`;

export const LeftColumn = styled(Column)`
  width: 450px;
`;

export const RightColumn = styled(Column)`
  background: ${({ theme }): string =>
    `linear-gradient(75.85deg, rgba(0, 0, 0, 0.012) 63.26%, rgba(0, 0, 0, 0.052) 95.14%), linear-gradient(270deg, ${theme.colors.bodyBg}, ${theme.colors.premiumModalBg})`};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 430px;
`;

export const StyledUl = styled.ul`
  color: ${({ theme }): string => theme.colors.gray};
  margin: 0;
  padding: 0 15px 30px 20px;
  list-style-position: outside;
  font-weight: 400;
`;

export const ButtonContainer = styled(Row)`
  width: 290px;
`;

export const WrappedContent = styled(Column)`
  flex-wrap: wrap;
  width: 100%;
  height: 230px;
`;

export const FeatureItem = styled(Row)`
  align-items: center;
`;

export const StyledRow = styled(Row)`
  white-space: pre-line;
  max-width: 120px;
  padding-left: 5px;
`;
